import {Node, mergeAttributes} from '@tiptap/core';
import Suggestion, {SuggestionOptions} from '@tiptap/suggestion';

export const Shortcodes = Node.create({
  name: 'shortcode',

  addOptions: {
    HTMLAttributes: {},
    suggestion: {
      char: '[',
      command: ({editor, range, props}) => {
        editor
          .chain()
          .focus()
          .insertContentAt(range, [
            {
              type: 'shortcode',
              attrs: props,
            },
            {
              type: 'text',
              text: ' ',
            },
          ])
          .run();
      },
      allow: ({editor, range}) => {
        return editor.can().insertContentAt(range, {type: 'shortcode'});
      },
    },
  },

  group: 'inline',

  inline: true,

  selectable: false,

  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => {
          return {
            id: element.getAttribute('data-shortcode'),
          };
        },
        renderHTML: attributes => {
          if (!attributes.id) {
            return {};
          }

          let id = attributes.id

          // sometimes the id is an object with id nested inside, so this accounts for that
          if (typeof attributes.id === "object") {
            id = attributes.id.id;
          }

          return {
            'data-shortcode': id,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-shortcode]',
      },
    ];
  },

  renderHTML({node, HTMLAttributes}) {
    let id = node.attrs.id;

    // sometimes the id is an object with id nested inside, so this accounts for that
    if (typeof node.attrs.id === "object") {
      id = node.attrs.id.id;
    }

    let attributes = HTMLAttributes

    // sometimes the id is an object with id nested inside, so this accounts for that
    if (typeof HTMLAttributes['data-shortcode'] === "object") {
      attributes = {
        'data-shortcode': HTMLAttributes['data-shortcode']['id']
      }
    }

    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      id,
    ];
  },

  renderText({node}) {
    let id = node.attrs.id;

    // sometimes the id is an object with id nested inside, so this accounts for that
    if (typeof node.attrs.id === "object") {
      id = node.attrs.id.id;
    }

    return `${this.options.suggestion.char}${id}`;
  },

  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({tr, state}) => {
        let isMention = false;
        const {selection} = state;
        const {empty, anchor} = selection;

        if (!empty) {
          return false;
        }

        state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
          if (node.type.name === this.name) {
            isMention = true;
            tr.insertText(this.options.suggestion.char || '', pos, pos + node.nodeSize);

            return false;
          }
        });

        return isMention;
      }),
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});
